import React from 'react';
import styled from 'styled-components';
import colors from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/colors.json';
import {
  APPOINTMENT_STATUS,
  CALENDAR_ITEM_TYPES,
  BLOCK_HOURS_CONFIG,
  BREAK_STAFF_CONFIG,
  saveAppointmentColor,
  CONFIRM_CONFIG,
  MULTI_CONFIG,
  NEW_CONFIG,
  CHECK_IN_CONFIG,
  CANCEL_CONFIG,
  NO_SHOW_CONFIG,
  GROUP_CONFIG,
} from 'features/appointment/services/constants';
import { useAppDispatch } from 'store/hooks';
import appointmentActions from 'features/appointment/services/actions';
import { useSignals } from '@preact/signals-react/runtime';

type SelectColorByConfigStatusProps = {
  value?: any;
};

const SelectColorByConfigStatus = ({ value }: SelectColorByConfigStatusProps) => {
  const dispatch = useAppDispatch();
  useSignals();

  const findActiveByConfig = (config: any) => {
    switch (config) {
      case 'MULTI':
      default:
        return `${MULTI_CONFIG.value.stroke}_${MULTI_CONFIG.value.fill}`;
      case APPOINTMENT_STATUS.NEW?.toString():
        return `${NEW_CONFIG.value.stroke}_${NEW_CONFIG.value.fill}`;
      case APPOINTMENT_STATUS.CONFIRM?.toString():
        return `${CONFIRM_CONFIG.value.stroke}_${CONFIRM_CONFIG.value.fill}`;
      case APPOINTMENT_STATUS.CHECK_IN?.toString():
        return `${CHECK_IN_CONFIG.value.stroke}_${CHECK_IN_CONFIG.value.fill}`;
      case APPOINTMENT_STATUS.CANCEL?.toString():
        return `${CANCEL_CONFIG.value.stroke}_${CANCEL_CONFIG.value.fill}`;
      case APPOINTMENT_STATUS.NO_SHOW?.toString():
        return `${NO_SHOW_CONFIG.value.stroke}_${NO_SHOW_CONFIG.value.fill}`;
      case CALENDAR_ITEM_TYPES.BREAK_STAFF?.toString():
        return `${BREAK_STAFF_CONFIG.value.stroke}_${BREAK_STAFF_CONFIG.value.fill}`;
      case CALENDAR_ITEM_TYPES.BLOCK_HOURS?.toString():
        return `${BLOCK_HOURS_CONFIG.value.stroke}_${BLOCK_HOURS_CONFIG.value.fill}`;
      case 'GROUP':
        return `${GROUP_CONFIG.value.stroke}_${GROUP_CONFIG.value.fill}`;
    }
  };
  const activeId = findActiveByConfig(value);

  const handleChangeColor = (id: string) => {
    const [stroke, fill] = id.split('_');
    saveAppointmentColor(value, fill, stroke);
    dispatch(
      appointmentActions.updateSettingBackground.fetch({
        color: id,
        status: value,
      })
    );
  };

  return (
    <Container>
      <ThemeContainer>
        <div className='title'>Theme 1</div>
        <div className='theme-list'>
          {colors.map((item, index) => (
            <div
              key={index}
              className={`${activeId === item.id ? 'theme-item-selected' : ''}`}
              onClick={() => handleChangeColor(item.id)}
            >
              <div
                className='theme-item'
                style={{ background: item.fill, border: `1px solid ${item.stroke}` }}
              />
            </div>
          ))}
        </div>
      </ThemeContainer>
    </Container>
  );
};

export default SelectColorByConfigStatus;

const Container = styled.div`
  flex: 1;
  padding: 24px 24px 24px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ThemeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  .title {
    color: #505050;
    font-size: 24px;
    font-weight: 600;
  }
  .theme-list {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 8px;
    width: 100%;
  }
  .theme-item {
    cursor: pointer;
    border: 1px solid #adadad;
    box-sizing: border-box;
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 4px;
    background: #fff;
  }
  .theme-item-selected {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    border: 1px solid #dc5500;
    background: #dc5500;
  }
`;
